module.exports = __webpack_public_path__ + "9485e09b12421622ff8ea7648ccc000d.ttf";


//////////////////
// WEBPACK FOOTER
// ./assets/Lato-Bold.ttf
// module id = 987
// module chunks = 0